import { Typography } from "@mui/material";
import { twMerge } from "tailwind-merge";

type TSplitTitleProps = {
	title: string;
	subTitle: string;
	className?: string;
};

const SplitTitle = (props: TSplitTitleProps) => {
	const { title = "", subTitle = "", className = "" } = props;
	const classes = twMerge("!font-montserrat text-default !text-[16px] !p-0 !font-[500]", className);
	return (
		<Typography className={classes}>
			{title} <br /> {subTitle}
		</Typography>
	);
};

export default SplitTitle;
